import { render, staticRenderFns } from "./Investigate.vue?vue&type=template&id=404c06fe&scoped=true&"
import script from "./Investigate.vue?vue&type=script&lang=js&"
export * from "./Investigate.vue?vue&type=script&lang=js&"
import style0 from "./Investigate.vue?vue&type=style&index=0&id=404c06fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404c06fe",
  null
  
)

export default component.exports